import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', color: 'white', borderTop: '3px solid #7c3aed'}}>
      {/* Trust Badges Section */}
      <div style={{background: 'rgba(124, 58, 237, 0.1)', padding: '2rem 0', borderBottom: '1px solid rgba(255,255,255,0.1)'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem'}}>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', textAlign: 'center'}}>
            <div>
              <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>🔒</div>
              <div style={{fontWeight: '600', marginBottom: '0.25rem'}}>TCPA Compliant</div>
              <div style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)'}}>Full Regulatory Compliance</div>
            </div>
            <div>
              <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>✓</div>
              <div style={{fontWeight: '600', marginBottom: '0.25rem'}}>A2P Registered</div>
              <div style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)'}}>Carrier Approved</div>
            </div>
            <div>
              <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>🏢</div>
              <div style={{fontWeight: '600', marginBottom: '0.25rem'}}>Established 2020</div>
              <div style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)'}}>Atlanta, GA</div>
            </div>
            <div>
              <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>⭐</div>
              <div style={{fontWeight: '600', marginBottom: '0.25rem'}}>Expert Team</div>
              <div style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)'}}>Professional Services</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem 2rem'}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', marginBottom: '3rem'}}>
          <div>
            <div style={{display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem', fontFamily: 'Poppins', fontSize: '1.5rem', fontWeight: '700'}}>
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <rect width="40" height="40" rx="8" fill="#7c3aed"/>
                <path d="M12 14h16v2.5H12z" fill="#ffffff"/>
                <path d="M16 19h10v2.5H16z" fill="#fbbf24"/>
                <path d="M14 24h12v2.5H14z" fill="#c4b5fd"/>
              </svg>
              <span style={{color: '#ffffff'}}>TEJ Solutions Hub</span>
            </div>
            <p style={{color: 'rgba(255,255,255,0.7)', lineHeight: '1.8', marginBottom: '1rem'}}>
              Full-service software development company providing web development, mobile apps, digital marketing, and cloud solutions.
            </p>
            <div style={{background: 'rgba(124, 58, 237, 0.2)', padding: '1rem', borderRadius: '8px', marginTop: '1rem'}}>
              <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.9)', marginBottom: '0.5rem'}}>
                <strong>Legal Entity:</strong> TEJ SUSTAINABILITY GROUP, INC.
              </p>
              <p style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.7)'}}>
                <strong>EIN:</strong> 86-3326707<br/>
                <strong>Founder:</strong> Zebedee McLaurin
              </p>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#a78bfa'}}>Services</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Web Development</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Mobile App Development</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Digital Marketing</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Cloud Infrastructure</Link>
              <Link to="/services" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>SMS/Email Campaigns</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#a78bfa'}}>Company</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <Link to="/about-us" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>About Us</Link>
              <Link to="/portfolio" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Portfolio</Link>
              <Link to="/pricing" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Pricing</Link>
              <Link to="/contact" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Contact</Link>
            </div>
          </div>
          
          <div>
            <h3 style={{fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: '#a78bfa'}}>Legal</h3>
            <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '2rem'}}>
              <Link to="/privacy-policy" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Privacy Policy</Link>
              <Link to="/terms-and-conditions" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Terms & Conditions</Link>
              <Link to="/sms-opt-in" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>SMS Opt-In Example</Link>
              <Link to="/opt-out" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>Opt-Out / Unsubscribe</Link>
              <Link to="/sms-opt-in-disclosure" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>SMS Opt-In Disclosure</Link>
              <Link to="/sms-compliance-consent" style={{color: 'rgba(255,255,255,0.7)', textDecoration: 'none'}}>SMS Compliance</Link>
            </div>
            <div>
              <h4 style={{fontSize: '1rem', fontWeight: '600', marginBottom: '0.75rem', color: '#ffffff'}}>Contact</h4>
              <p style={{color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', lineHeight: '1.6'}}>
                4273 Savannah Trce<br/>
                Atlanta, GA 30349<br/>
                contact@tejsolutionshub.com
              </p>
            </div>
          </div>
        </div>
        
        <div style={{paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center'}}>
          <p style={{color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem'}}>
            © {new Date().getFullYear()} TEJ SUSTAINABILITY GROUP, INC. (d/b/a TEJ Solutions Hub). All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
